import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, fetchhistory, updateData, postData, fetchEngineerStockDetails } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import InvoiceIcon from './InvoiceIcon';
import { Tooltip } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import PrintIcon from '@mui/icons-material/Print';
import DeleteIcon from '@mui/icons-material/Delete';
import Modal from '@mui/material/Modal';
import { useHistory, useParams } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa';
import { FaTimes } from 'react-icons/fa';
import ReceiptIcon from '@mui/icons-material/Receipt';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import SmsIcon from '@mui/icons-material/Sms';
import EmailIcon from '@mui/icons-material/Email';
import html2pdf from 'html2pdf.js';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import { sendWhatsAppMessage } from './../../../apiService';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

function WorkStatusIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [selectedSparepartss, setSelectedSparepartss] = useState("");
    const [formData, setFormData] = useState({});
    const [Remark, setRemark] = useState("");
    const [id, setId] = useState("");
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token, companyName } = useAuth();
    const [openModals, setOpenModal] = useState(false);
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        fetchtableData();
    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchtableData();
    }, []);

    const fetchtableData = async () => {

        fetchData('ScheduleServiceApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setData(response.response_data);

                }
            })
            .catch((error) => {
                console.error('Error fetching Request Details:', error);
            });

    };

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };


    const handleRequest = (id) => {
        console.log(`Request action clicked for item with id ${id}`);
    };
    const [modalOpen, setModalOpen] = useState(false);
    const openModal = () => {
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    const [selectedStaff, setSelectedStaff] = useState('');
    const [staffOptions, setStaffOptions] = useState([]);

    const fetchStaff = async () => {
        try {
            const response = await fetchData('StaffApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                setStaffOptions(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Work Types:', error);
        }
    };

    useEffect(() => {
        fetchStaff();
    }, []);

    const [selectedRequestId, setSelectedRequestId] = useState(null);
    const [allocateModalOpen, setAllocateModalOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedStaffIds, setSelectedStaffIds] = useState([]);
    const handleRequestAllocation = (id) => {
        setSelectedRequestId(id);
        setAllocateModalOpen(true);
    };

    const [workTypeOptions, setWorkTypeOptions] = useState([]);
    const [selectedWorkStatus, setSelectedWorkStatus] = useState("");

    const fetchWorkTypes = async () => {
        try {
            const response = await fetchData('WorkStatusApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                setWorkTypeOptions(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Work Types:', error);
        }
    };

    useEffect(() => {
        fetchWorkTypes();
    }, []);

    const filteredData = data.filter((item) =>
        (selectedWorkStatus === "" || item.workstatus === selectedWorkStatus) &&
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const [invoiceItems, setInvoiceItems] = useState([]);
    const [selectedInvoiceDetails, setSelectedInvoiceDetails] = useState(null);
    const [isInvoiceDialogOpen, setIsInvoiceDialogOpen] = useState(false);

    const handleCloseInvoiceDialog = () => {
        setIsInvoiceDialogOpen(false);
    };

    const [selectedQuantity, setSelectedQuantity] = useState(1);
    const [selectedSparepart, setSelectedSparepart] = useState('');
    const [sparepartsOptions, setSparepartsOptions] = useState([]);
    const [SpareID, setSpareID] = useState('');
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetchEngineerStockDetails('EngineerStockApi', companyId, userId, token);
                if (response.responseCode === '1111') {
                    const firstSparepart = response.response_data[0];
                    if (firstSparepart) {
                        setSparepartsOptions(response.response_data);
                        setSpareID(firstSparepart.id);
                        console.log(response.response_data);
                    }
                }
            } catch (error) {
                console.error('Error occurred while fetching data:', error);
            }
        };

        fetchData();
    }, [companyId, userId, token]);

    //Product Type
    const [productTypeOptions, setProductTypeOptions] = useState([]);
    const [selectedProductType, setSelectedProductType] = useState("");

    const fetchProductTypes = async () => {
        try {
            const response = await fetchData('ProductApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                setProductTypeOptions(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Product Types:', error);
        }
    };

    const [addedSpareparts, setAddedSpareparts] = useState([]);
    const [itemList, setItemList] = useState([]);

    const addSparepart = () => {
        selectedSpareparts.forEach((selectedItem) => {
            const foundItem = sparepartsOptions.find(item => item.name === selectedItem);
            if (foundItem) {
                const newItem = {
                    ID: foundItem.id,
                    companyID: companyId,
                    Itemname: foundItem.spareName,
                    SaleRate: foundItem.saleRate,
                };
                setItemList(prevItems => [...prevItems, newItem]);

            }
        });
        setSelectedSpareparts([]);
    };

    const addInvoiceItem = (item, quantity, rate, amount) => {
        setInvoiceItems(prevItems => [...prevItems, { item, quantity, rate, amount }]);
    };

    const removeSparepart = (index) => {
        const updatedSpareparts = [...selectedSpareparts];
        updatedSpareparts.splice(index, 1);
        setSelectedSpareparts(updatedSpareparts);
    };

    const calculateAmount = (sparepart, quantity) => {
        return sparepart.SaleRate * quantity;
    };

    const [selectedSpareparts, setSelectedSpareparts] = useState([]);

    // const [openModal, setOpenModal] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleClick = () => {
        setIsModalOpen(true);
    };

    const closeModals = () => {
        setIsModalOpen(false);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        closeModal(); // Close the modal when the main modal is closed
    };


    // Function to handle deleting a row from the grid
    const handleDeleteRow = (index) => {
        const updatedGridData = [...gridData];
        updatedGridData.splice(index, 1);
        setGridData(updatedGridData);
    };

    const [gridData, setGridData] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState('');
    const [quantity, setQuantity] = useState('');
    const [rate, setRate] = useState('');
    const [amount, setAmount] = useState('');

    const fetchSpareTypes = async () => {
        try {
            const response = await fetchData('SparePartsApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                setSparepartsOptions(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Product Types:', error);
        }
    };

    useEffect(() => {
        fetchProductTypes();
        fetchSpareTypes();
    }, []);


    const handleAddRow = () => {
        if (!selectedProductType || !quantity || !rate || !amount || !salerate) {
            alert('Please fill all fields');
            return;
        }
        const newRow = { product: selectedProductType, selectedSparepartss, quantity, rate, amount, salerate };
        setGridData([...gridData, newRow]);
        setSelectedProduct('');
        setQuantity('');
        setRate('');
        setAmount('');
        setSalerate('');
    };
    const [salerate, setSalerate] = useState('');
    const [productname, setProductname] = useState('');
    const [productCode, setProductCode] = useState('');
    const [gst, setGst] = useState('');

    const saveItemsToServer = async (items) => {
    };

    const handleSubmits = (event) => {
        event.preventDefault();
        const updatedFormData = { ...formData, workstatus: selectedWorkStatus, Remarks: Remark };
        updateData('EngineerVisitApi', `${id}`, updatedFormData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                saveItemsToServer(gridData)
                    .then((response) => {
                        console.log('Items saved successfully:', response);
                        history.push('/WorkStatusIndex');
                    })
                    .catch((error) => {
                        console.error('Error saving items:', error);
                    });
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    const [allFieldsFilled, setAllFieldsFilled] = useState(false);
    useEffect(() => {
        const fieldsFilled =
            productname !== '' &&


            setAllFieldsFilled(fieldsFilled);
    }, [productname]);

    const handleProductTypeChange = (e) => {
        const selectedProduct = e.target.value;
        const foundProduct = productTypeOptions.find(product => product.name === selectedProduct);
        if (foundProduct) {
            setSelectedProductType(selectedProduct);
            const updatedItem = {
                ...newItem,
                Name: selectedProduct,
                SaleRate: foundProduct.rate,
                ProductID: foundProduct.id,
                GSTRate: foundProduct.gstRate
            };
            setNewItem(updatedItem);
        }
    };

    const handleSpareTypeChange = (e) => {
        const selectedSpare = e.target.value;
        const foundSpare = sparepartsOptions.find(spare => spare.spareName === selectedSpare);
        if (foundSpare) {
            setSelectedSpareparts(selectedSpare);
            const updatedItem = {
                ...newItem,
                Name: selectedSpare,
                SaleRate: foundSpare.saleRate,
                SparepartsID: foundSpare.id,
                GSTRate: foundSpare.gstRate
            };
            setNewItem(updatedItem);
        }
    };

    const [newItem, setNewItem] = useState({
        Name: '',
        SaleRate: 0,
        GST: 0,
        quantity: 1
    });

    // implementing the GST Concept

    const AddtoListdata = (e) => {
        e.preventDefault();

        const updatedItem = { ...newItem };
        // Calculate GST amount
        const gstAmount = (newItem.quantity * newItem.SaleRate * newItem.GSTRate) / 100;
        // Split GST into CGST and SGST
        const cgstAmount = gstAmount / 2;
        const sgstAmount = gstAmount / 2;
        // Calculate total amount including GST
        updatedItem.Amount = newItem.quantity * newItem.SaleRate + gstAmount;
        updatedItem.CGSTAmount = cgstAmount;
        updatedItem.SGSTAmount = sgstAmount;
        // Add updated item to the list
        setItemList([...itemList, updatedItem]);

        // Resetting fields to initial values
        setNewItem({
            Name: '',
            SaleRate: 0,
            GSTRate: 0,
            quantity: 1,
            ...(selectedOption === 'spare' && { SpareParts: selectedSpareparts })
        });
        setSelectedProductType('');
        setSelectedSpareparts('');
    };


    const [selectedOption, setSelectedOption] = useState('product');
    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);

    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);

    };

    const handleDelete = () => {
        if (itemToDeleteIndex !== null) {
            const updatedItemList = itemList.filter((_, i) => i !== itemToDeleteIndex);
            setItemList(updatedItemList);
            closeConfirmDialog();
        }
    };


    const [invoiceNumber, setInvoiceNumber] = useState(0);

    useEffect(() => {

        const lastInvoiceNumber = localStorage.getItem('lastInvoiceNumber');
        if (lastInvoiceNumber) {
            setInvoiceNumber(parseInt(lastInvoiceNumber) + 1);
        }
    }, []);

    const handleGenerateInvoice = (customer, remarks, requestID, customerID, number, address, customertype) => {
        const currentDate = new Date().toLocaleDateString('en-GB');
        //const currentDateTime = new Date().toLocaleString('en-GB');
        // setInvoiceNumber(prevInvoiceNumber => prevInvoiceNumber + 1);
        setSelectedInvoiceDetails({ customer, remarks, dateTime: currentDate, selectedSparepart, selectedQuantity, requestID, customerID, number, address, customertype });
        setIsInvoiceDialogOpen(true);
    };

    //generate the Bill details 
    const [isSubmitDialogOpen, setSubmitDialogOpen] = useState(false);

    const handleCloseInvoiceSubmitDialog = () => {
        setSubmitDialogOpen(false);
    };

    const handleOpenSubmitDialog = (tempstr, requestID) => {
        setSubmitDialogOpen(true);
        handleGenerateBillstatus(tempstr, requestID);
    };

    //update invoice 
    const handleEditInvoice = (tempstr, EngineerVisitID) => {
        handleGenerateBillEdit(tempstr, EngineerVisitID);
        setIsInvoiceEditOpen(true); // Open the edit modal
    };


    const handleGenerateBillEdit = (tempstr, EngineerVisitID) => {
        fetchData('InvoicedItemApi', `/${tempstr}/${EngineerVisitID}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setBillData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Request Details:', error);
            });
    };


    const [billdata, setBillData] = useState([]);
    const handleGenerateBillstatus = (tempstr, requestID) => {
        fetchData('InvoicedItemApi', `/${tempstr}/${requestID}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setBillData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Request Details:', error);
            });
    };

    useEffect(() => {
        const tempstr = '';
        const requestID = '';
        handleGenerateBillstatus(tempstr, requestID);
    }, []);

    // Add state variables for additional fields
    const [Discount, setDiscount] = useState(0);
    const [NetAmount, setNetAmount] = useState(0);
    const [CGSTAmount, setCGSTAmount] = useState(0);
    const [SGSTAmount, setSGSTAmount] = useState(0);
    const [IGSTAmount, setIGSTAmount] = useState(0);
    const [Roundoff, setRoundoff] = useState(0);
    const [TotalAmount, setTotalAmount] = useState(0);
    const [PaidAmount, setPaidAmount] = useState(0);
    const [BalanceAmount, setBalanceAmount] = useState(0);
    const [paymentType, setPaymentType] = useState('UPI');
    //calculation 
    const netAmount = itemList.reduce((acc, item) => acc + item.Amount, 0);
    const totalAmount = itemList.reduce((acc, item) => acc + item.Amount, 0) - Discount;
    const balanceAmount = totalAmount - PaidAmount;

    const sgst = itemList.reduce((acc, item) => acc + item.SGSTAmount, 0)
    const cgst = itemList.reduce((acc, item) => acc + item.CGSTAmount, 0)

    useEffect(() => {
        const lastInvoiceNumber = localStorage.getItem('lastInvoiceNumber');
        if (lastInvoiceNumber) {
            setInvoiceNumber(parseInt(lastInvoiceNumber) + 1);
        }
    }, []);

    const [formDatas, setFormDatas] = useState({
        PaymentType: 1 // Default to "Cash" (1)

    });

    const handleToggle = () => {
        setFormDatas(prevState => ({
            ...prevState,
            PaymentType: prevState.PaymentType === 1 ? 2 : 1
        }));
    };


    const handleInvoiceItemSubmit = async () => {
        try {

            const invoiceItems = itemList.map(item => {

                return {
                    EngineerVisitID: selectedInvoiceDetails.requestID,
                    Customer: selectedInvoiceDetails.customer,
                    CustomerID: selectedInvoiceDetails.customerID,
                    CompanyID: companyId,
                    SparepartsID: item.SparepartsID,
                    ProductID: item.ProductID,
                    Quantity: item.quantity,
                    Rate: item.SaleRate,
                    GSTRate: item.GSTRate,
                    CGSTAmount: item.CGSTAmount,
                    SGSTAmount: item.SGSTAmount,
                    IGSTAmount: item.IGSTAmount,
                    TotalAmount: item.Amount,
                    BilledDate: new Date(),
                    CreatedBy: userId,
                    CreatedDate: new Date(),
                };
            });

            const saleMaster = {
                companyid: companyId,
                EngineerVisitID: selectedInvoiceDetails.requestID,
                CustomerID: selectedInvoiceDetails.customerID,
                BillStatusID: null,
                InvoiceDate: new Date(),
                InvoiceNo: invoiceNumber,
                Amount: netAmount,
                NetAmount: netAmount,
                TotalAmount: netAmount,
                IsPaymentMethod: formDatas.PaymentType,
                CGSTAmount: cgst,
                SGSTAmount: sgst,
                IGSTAmount: 0,
                Roundoff: 0,
                PaidAmount: 0,
                BalanceAmount: 0,
                Discount: 0,
                CreatedBy: userId,
                CreatedDate: new Date(),
            };

            const CreatedData = {
                sale: saleMaster,
                invoice: invoiceItems,

            };

            postData('InvoicedItemApi', CreatedData, token)
                .then((response) => {
                    console.log('Invoice Created success:', response);
                    history.push('/WorkStatusIndex');
                    setTimeout(() => {
                        window.location.reload()
                    }, 3000);
                })
                .catch((error) => {
                    console.error('Invoice Create error:', error);
                });
        }
        catch (error) {
            console.error('Invoice Create error:', error);
        }
    };

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head><title>' + companyName + '</title></head><body>');
        printWindow.document.write('<div style="border: 2px solid #000; padding: 20px;">');
        printWindow.document.write('<h4 style="text-align: center;">' + companyName + '</h4>');
        printWindow.document.write('<p style="text-align: center;">' + billdata[0]?.cmpyadd + '</p>');

        printWindow.document.write('<h4 style="font-size: 22px; font-weight: bold; margin-bottom: 20px; text-align: center;">Invoice Details</h4>');
        printWindow.document.write('<div>');
        printWindow.document.write('<div style="display: flex; justify-content: space-between;">');
        printWindow.document.write('<div><p>Name: ' + billdata[0]?.customer + '</p></div>');
        printWindow.document.write('<div>');
        printWindow.document.write('<p style="margin-bottom: 4px;">Bill No: ' + billdata[0]?.invoiceNo + '</p>');

        // Format the date
        const billDate = new Date(billdata[0]?.invoiceDate);
        const formattedBillDate = billDate.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });

        printWindow.document.write('<p style="margin-bottom: 4px;">Bill Date: ' + formattedBillDate + '</p>');
        printWindow.document.write('<p style="margin-bottom: 4px;">Payment Method: ' + billdata[0]?.isPaymentMethod + '</p>');
        printWindow.document.write('</div>');
        printWindow.document.write('</div>');

        printWindow.document.write('<div class="overflow-auto">');
        printWindow.document.write('<table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">');
        printWindow.document.write('<thead>');
        printWindow.document.write('<tr style="background-color: #f3f3f3;">');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bold;">HSN Code</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bold;">Product</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bold;">QTY</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bold;">Rate</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bold;">Taxable Amount</th>');
        printWindow.document.write('<th colspan="2" style="border: 1px solid #ddd; font-size: 19px; font-weight: bold;">CGST</th>');
        printWindow.document.write('<th colspan="2" style="border: 1px solid #ddd; font-size: 19px; font-weight: bold;">SGST</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bold;">Total Amount</th>');
        printWindow.document.write('</tr>');
        printWindow.document.write('</thead>');
        printWindow.document.write('<tbody>');

        let taxableAmount = 0;
        let totalCGST = 0;
        let totalSGST = 0;

        billdata.forEach((item, index) => {
            printWindow.document.write('<tr>');
            printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;">' + (item.hsnCode || '') + '</td>');
            printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;">' + (item.product || item.spareparts || '') + '</td>');
            printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;">' + (item.quantity || '') + '</td>');
            printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px; text-align: right;">' + (item.salerate || '') + '</td>');
            printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px; text-align: right;">' + (item.inAmount || '') + '</td>');
            printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;">' + (item.cgstPercent || '') + '%</td>');
            printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;">' + (item.cgstAmount || '') + '</td>');
            printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;">' + (item.sgstPercent || '') + '%</td>');
            printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;">' + (item.sgstAmount || '') + '</td>');
            printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px; text-align: right;">' + (item.netAmount || '') + '</td>');
            printWindow.document.write('</tr>');

            taxableAmount += parseFloat(item.inAmount);
            totalCGST += parseFloat(item.cgstAmount);
            totalSGST += parseFloat(item.sgstAmount);
        });


        printWindow.document.write('</tbody></table></div>');
        printWindow.document.write('<div style="display: flex; justify-content: space-between; margin-top: 20px;">');
        printWindow.document.write('<div></div>');
        printWindow.document.write('<div>');

        printWindow.document.write('<p>Total CGST: ' + totalCGST.toFixed(2) + '</p>');
        printWindow.document.write('<p>Total SGST: ' + totalSGST.toFixed(2) + '</p>');
        printWindow.document.write('<p> Taxable Amount: ' + taxableAmount.toFixed(2) + '</p>');
        printWindow.document.write('</div>');
        printWindow.document.write('</div>');

        printWindow.document.write('</div>'); // Close the border container
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.print();
    };



    // end here still working

    const handleWhatsAppClick = async () => {
        try {
            // Generate the invoice PDF
            const pdfData = await generatePDF();

            // Get the customer's contact number
            const customerContact = billdata[0]?.customerContactNumber;

            // Send message via WhatsApp with PDF attachment and customer contact number
            await sendWhatsAppMessage(pdfData, customerContact);

            // Optionally show a success message or perform other actions
        } catch (error) {
            // Handle any errors, e.g., display an error message
            console.error('Error sending WhatsApp message:', error);
        }
    };

    const generatePDF = () => {
        return new Promise((resolve, reject) => {
            const element = document.getElementById('modal-content');
            const opt = {
                margin: 1,
                filename: 'invoice.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
            };
            html2pdf().from(element).set(opt).toPdf().get('pdf').then(function (pdf) {
                resolve(pdf.output('blob'));
            });
        });
    };

    const handleInvoiceItemEditSubmit = () => {
        const updatedItemList = [...itemList];
        updatedItemList[itemToEditIndex] = {
            ...updatedItemList[itemToEditIndex],
            Name: newItem.Name,
            quantity: newItem.quantity,
            SaleRate: newItem.SaleRate,
            GSTRate: newItem.gstRate,
            CGSTAmount: newItem.CGSTAmount,
            SGSTAmount: newItem.SGSTAmount,
            Amount: newItem.Amount
        };

        setItemList(updatedItemList);

        handleCloseInvoiceEditDialog();
    };

    const handleCloseInvoiceEditDialog = () => {
        setNewItem({});
        setItemToEditIndex(null);
        setIsInvoiceEditOpen(false);
    };

    const [itemToEditIndex, setItemToEditIndex] = useState(null);
    const [isInvoiceEditOpen, setIsInvoiceEditOpen] = useState(false);
    const tempstr = '0';

    // Define handleItemChange function to update billdata
    const handleItemChange = (index, field, value) => {
        // Create a copy of the billdata array
        const updatedBilldata = [...billdata];
        // Update the specific field of the item at the given index
        updatedBilldata[index][field] = value;
        // Update the state with the modified billdata array
        setBillData(updatedBilldata);
    };

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto">
            <div className='w-full mb-2 flex'>
                <h3 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Times New Roman', color: 'black' }}>Assigned Service</h3>

            </div>
            <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>

                <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                {showSearchInput && (
                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        style={{ marginLeft: '10px', width: '200px' }}
                    />
                )}
            </div>
            <div className='w-full mb-5 flex' style={{ maxHeight: '600px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table>

                        <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '18px' }}>Sl.No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '18px' }}>Date</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '18px' }}>Name</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '18px' }}>Contact No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '18px' }}>Address</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '18px' }}>Warranty</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '18px' }}>Remarks</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '18px' }}>Request</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '18px' }}>W.status</TableCell>
                                {/* <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '18px' }}>Actions</TableCell> */}
                            </TableRow>
                        </TableHead>
                        <TableBody>


                            {/* {data.map(item => ( */}
                            {filteredData.map((item, index) => (
                                <TableRow key={item.Id} className="customTableRows">
                                    <TableCell sx={{ padding: '3px',fontSize: '14px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ padding: '3px',fontSize: '14px' }}>
                                        {item.createdDate && new Date(item.createdDate).toLocaleDateString('en-GB')}
                                    </TableCell >
                                    <TableCell sx={{ padding: '3px',fontSize: '14px' }}>{item.customer}
                                        <p>({item.customertype})</p>
                                    </TableCell>
                                    <TableCell sx={{ padding: '3px',fontSize: '14px' }}>{item.number}</TableCell>
                                    <TableCell sx={{ padding: '3px',fontSize: '14px' }}>{item.address}
                                        <p>({item.landmark},{item.pincode})</p> </TableCell>

                                    <TableCell sx={{ padding: '3px',fontSize: '14px' }}>{item.warranty}</TableCell>
                                    <TableCell sx={{ padding: '3px',fontSize: '14px' }}>{item.remarks}
                                        <p>({item.product})</p> </TableCell>

                                    <TableCell sx={{ padding: '3px',fontSize: '14px' }}>{item.serviceRequestTypes}</TableCell>
                                    <TableCell sx={{ padding: '3px',fontSize: '14px' }}>{item.engineerWorkSS}</TableCell>
                                    {/* <TableCell sx={{ padding: '3px',fontSize: '14px' }}>

                                        {item.workstatus !== 'Completed' && (
                                            <Link to={`/UpdateRequest/${item.requestID}`}>

                                                <Tooltip title="Info">
                                                    <IconButton>
                                                        <InfoIcon />
                                                    </IconButton>
                                                </Tooltip>

                                            </Link>
                                        )}

                                        {(item.workstatus === 'Completed' && !item.isgenerated) && (
                                            <Tooltip title="Invoice">
                                                <IconButton onClick={() => handleGenerateInvoice(item.customer, item.remarks, item.requestID, item.customerID, item.number, item.address , item.customertype)}>
                                                    <InvoiceIcon />
                                                </IconButton>
                                            </Tooltip>
                                        )}

                                        {item.workstatus === 'Completed' && item.isgenerated && (
                                            <Tooltip title="Bill Print">
                                                <IconButton onClick={() => handleOpenSubmitDialog(tempstr, item.requestID)}>
                                                    <ReceiptIcon style={{ color: 'green' }} />
                                                </IconButton>
                                            </Tooltip>
                                        )}

                                        {item.workstatus === 'Completed' && item.isgenerated && (
                                            <Tooltip title="Invoice-Print">

                                                <IconButton onClick={handlePrint}>
                                                    <PrintIcon />
                                                </IconButton>

                                            </Tooltip>
                                        )}
                                    </TableCell> */}
                                </TableRow>
                            ))}
                        </TableBody>

                    </Table>
                </TableContainer>
                {/* Invoice Details Dialog */}
                <Modal open={isInvoiceDialogOpen} onClose={handleCloseInvoiceDialog}>

                    <div className="fixed inset-0 flex items-center justify-center z-10" style={{ overflow: 'auto' }}>
                        <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '1000px', overflowX: 'auto', overflowY: 'auto' }}>

                            <div className="flex justify-end mt-2" style={{ marginTop: '-45px' }}>
                                <Tooltip title="Back-To-List">
                                    <Button
                                        variant="contained"
                                        color="error"
                                        component={Link}
                                        onClick={handleCloseInvoiceDialog}
                                        className="linkcolor"
                                        style={{ marginLeft: '8px' }}
                                    >
                                        <CancelIcon />
                                    </Button>
                                </Tooltip>
                                <Tooltip title="Save">
                                    <Button
                                        variant="contained"
                                        color="success"
                                        component={Link}
                                        onClick={handleInvoiceItemSubmit}
                                        className="linkcolor"
                                        style={{ marginLeft: '8px', float: 'right' }}
                                        startIcon={<CheckCircleOutlineIcon />}
                                    >
                                    </Button>
                                </Tooltip>
                            </div>
                            <div>

                            </div>
                            <h2 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Times New Roman', color: 'black', textAlign: 'center' }}>INVOICE DETAILS</h2>


                            <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '20px' }}>
                                <div>
                                    Name  : <strong>{selectedInvoiceDetails?.customer}</strong><br />
                                    Address: <strong>{selectedInvoiceDetails?.address}</strong><br />
                                    Contact   : <strong>{selectedInvoiceDetails?.number}</strong><br />
                                    Type : <strong>{selectedInvoiceDetails?.customertype}</strong>
                                </div>
                                <div style={{ marginTop: '-20px' }}>
                                    <h6 style={{ color: 'blue' }}>Payment mode</h6>

                                    <div className="w-1/8" style={{ marginTop: "10px" }}>
                                        <label className="toggleSwitch xSmall">
                                            <input
                                                type="checkbox"
                                                id="toggle-switch"
                                                name="PaymentType"
                                                checked={formDatas.PaymentType === 2}
                                                onChange={handleToggle}
                                                style={{ display: "none" }}
                                            />
                                            <span>
                                                <span>Cash</span>
                                                <span>UPI</span>
                                            </span>
                                            <a></a>
                                        </label>
                                    </div>

                                    <div>
                                        <p style={{ color: 'black', fontWeight: 'bolder' }}>Net Amount : ₹{netAmount}</p>
                                    </div>

                                </div>

                            </div>


                            <div>
                                <div className="w-full mb-4 flex">
                                    <div className="w-1/2 mr-2" style={{ marginLeft: '20px' }}>
                                        <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="spareparts" style={{ fontSize: '16px' }}>
                                            Spare
                                        </label>
                                        <select
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline blackText"
                                            value={selectedSpareparts}
                                            onChange={handleSpareTypeChange}
                                        >
                                            <option value="">Spare parts</option>
                                            {sparepartsOptions.map((type) => (
                                                <option key={type.id} value={type.spareName}>
                                                    {type.spareName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="w-1/6 mr-2">
                                        <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="AddressLine1">
                                            Qty
                                        </label>
                                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                            value={newItem.quantity}
                                            onChange={(e) => setNewItem({ ...newItem, quantity: e.target.value })}
                                        />
                                        {selectedSpareparts && (
                                            <div className="w-full mb-2 flex justify-end" style={{ marginLeft: '75px', marginTop: '-40px' }}>
                                                <button
                                                    className="ml-2 bg-blue-500 text-white px-3 py-2 rounded"
                                                    onClick={AddtoListdata}
                                                >
                                                    ADD
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="bg-tabcolor rounded-lg shadow-lg p-6" style={{ marginTop: '10px', backgroundColor: 'rgba(255, 255, 255, 0.5)' }}>

                                <div className="w-full mb-4 flex">
                                    <div className="w-full mb-4 flex">
                                        <TableContainer component={Paper}>
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>Sl.No</th>
                                                        <th> Name</th>
                                                        <th>Qty</th>
                                                        <th>Rate</th>
                                                        <th>GST</th>
                                                        <th>Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {itemList.map((item, index) => (
                                                        <tr key={index}>
                                                            <td className="px-4 py-2 border-r">{index + 1}</td>
                                                            <td className="px-4 py-2 border-r">{item.Name}</td>
                                                            <td className="px-4 py-2 border-r">{item.quantity}</td>
                                                            <td className="px-4 py-2 border-r">{item.SaleRate}</td>
                                                            <td className="px-4 py-2 border-r">{item.GSTRate}</td>
                                                            <td className="px-4 py-2">{item.Amount}
                                                                <Tooltip title="Delete">
                                                                    <DeleteIcon
                                                                        style={{ color: 'violet', cursor: 'pointer', marginLeft: '20px' }}
                                                                        onClick={() => openConfirmDialog(index)}
                                                                    />
                                                                </Tooltip>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>

                                            </table>

                                        </TableContainer>
                                        <Dialog
                                            open={confirmDialogOpen}
                                            onClose={closeConfirmDialog}
                                            aria-labelledby="alert-dialog-title"
                                            aria-describedby="alert-dialog-description"
                                        >
                                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                            <DialogContent>
                                                <DialogContentText id="alert-dialog-description">
                                                    Are you sure you want to delete this record?
                                                </DialogContentText>
                                            </DialogContent>

                                            <DialogActions>
                                                <button
                                                    onClick={closeConfirmDialog}
                                                    style={{
                                                        backgroundColor: '#dc3545',
                                                        color: '#ffffff',
                                                        border: '1px solid #dc3545',
                                                        borderRadius: '4px',
                                                        padding: '8px 16px',
                                                        cursor: 'pointer',
                                                        marginRight: '8px',
                                                    }}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    onClick={() => handleDelete(itemToDeleteIndex)}
                                                    style={{
                                                        backgroundColor: '#28a745',
                                                        color: '#ffffff',
                                                        border: '1px solid #28a745',
                                                        borderRadius: '4px',
                                                        padding: '8px 16px',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    Confirm
                                                </button>
                                            </DialogActions>

                                        </Dialog>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </Modal >

                <Modal open={isSubmitDialogOpen} onClose={handleCloseInvoiceSubmitDialog}>
                    <div className="fixed inset-0 flex items-center justify-center z-10" style={{ overflow: 'auto' }}>

                        <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '1000px', overflowX: 'auto', overflowY: 'auto' }}>
                            {/* Close icon */}
                            <div className="flex justify-end mt-2">
                                <Tooltip title="Close">
                                    <button className="absolute bottom-2 right-2 md:static md:mr-2" onClick={handleCloseInvoiceSubmitDialog}>
                                        <FaTimes />
                                    </button>
                                </Tooltip>
                            </div>
                            <br></br>
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>

                                {/* <IconButton onClick={handleWhatsAppClick}>
                                    <Tooltip title="Whatsapp">
                                        <WhatsAppIcon style={{ color: '#25D366' }} />
                                    </Tooltip>
                                </IconButton>

                                <IconButton>
                                    <Tooltip title="SMS">
                                        <SmsIcon style={{ color: '#FFA500' }} />
                                    </Tooltip>
                                </IconButton>

                                <IconButton>
                                    <Tooltip title="Email">
                                        <EmailIcon style={{ color: '#007bff' }} />
                                    </Tooltip>
                                </IconButton> */}

                                <IconButton onClick={() => handleEditInvoice(tempstr, billdata[0].engineerVisitID)}>
                                    <Tooltip title="Edit">
                                        <EditIcon style={{ color: '#000000' }} />
                                    </Tooltip>
                                </IconButton>

                               

                            </div>

                            <div className="modal-content">

                                <h3 style={{ textAlign: 'center', fontFamily: 'Times New Roman', marginTop: '-50px', fontWeight: 'bolder' }}>Invoice</h3>
                                <br></br>

                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div>
                                        <p style={{ marginBottom: '4px' }}>Name:<strong>{billdata[0]?.customer}</strong></p>
                                        <p style={{ marginBottom: '4px' }}>Address:<strong>{billdata[0]?.customerAddress}</strong></p>
                                        <p style={{ marginBottom: '4px' }}>Contact: <strong>{billdata[0]?.customerContactNumber}</strong></p>
                                    </div>
                                    <div>
                                        <p style={{ marginBottom: '4px' }}>Payment Method: {billdata[0]?.isPaymentMethod}</p>
                                        <p style={{ color: 'black', fontWeight: 'bolder' }}>Net Amount : ₹{billdata[0]?.netAmount}</p>
                                    </div>

                                </div>

                                <div className="overflow-auto">
                                    <table className="w-full border-collapse border">
                                        <thead>
                                            <tr className="bg-gray-200 border-b">
                                                <th className="px-4 py-2 text-left border-r">Sl.no</th>
                                                <th className="px-4 py-2 text-left border-r">Product</th>
                                                <th className="px-4 py-2 text-left border-r">Quantity</th>
                                                <th className="px-4 py-2 text-left border-r">Rate</th>
                                                <th className="px-4 py-2 text-left border-r">GST</th>
                                                <th className="px-4 py-2 text-left">Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {billdata.map((item, index) => (
                                                <tr key={index} className={index % 2 === 0 ? 'bg-gray-100' : 'bg-white'}>
                                                    <td className="px-4 py-2 border-r">{index + 1}</td>
                                                    <td className="px-4 py-2 border-r">{item.product || item.spareparts}</td>
                                                    <td className="px-4 py-2 border-r">{item.quantity}</td>
                                                    <td className="px-4 py-2 border-r">{item.salerate}</td>
                                                    <td className="px-4 py-2 border-r">{item.gstrate}</td>
                                                    <td className="px-4 py-2">{item.inAmount}</td>
                                                </tr>
                                            ))}

                                        </tbody>
                                    </table>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div>

                                        </div>

                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                {/* Invoice Edit  */}
                <Modal open={isInvoiceEditOpen} onClose={handleCloseInvoiceEditDialog}>
                    <div className="fixed inset-0 flex items-center justify-center z-10" style={{ overflow: 'auto' }}>
                        <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '1000px', overflowX: 'auto', overflowY: 'auto' }}>

                            <div className="flex justify-end mt-2" style={{ marginTop: '-45px' }}>
                                <Tooltip title="Cancel">
                                    <Button
                                        variant="contained"
                                        color="error"
                                        component={Link}
                                        onClick={handleCloseInvoiceEditDialog}
                                        className="linkcolor"
                                        style={{ marginLeft: '8px' }}
                                    >
                                        <CancelIcon />
                                    </Button>
                                </Tooltip>

                            </div>
                            <div>

                            </div>
                            <h2 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Times New Roman', color: 'black', textAlign: 'center' }}>INVOICE EDIT</h2>

                            <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '20px' }}>
                                <div>
                                    <p style={{ marginBottom: '4px' }}>Name:<strong>{billdata[0]?.customer}</strong></p>
                                    <p style={{ marginBottom: '4px' }}>Address:<strong>{billdata[0]?.customerAddress}</strong></p>
                                    <p style={{ marginBottom: '4px' }}>Contact: <strong>{billdata[0]?.customerContactNumber}</strong></p>
                                </div>
                                <div style={{ marginTop: '-20px' }}>
                                    <h6 style={{ color: 'blue' }}>Payment mode</h6>

                                    <div className="w-1/8" style={{ marginTop: "10px" }}>
                                        <label className="toggleSwitch xSmall">
                                            <input
                                                type="checkbox"
                                                id="toggle-switch"
                                                name="PaymentType"
                                                checked={formDatas.PaymentType === 2}
                                                onChange={handleToggle}
                                                style={{ display: "none" }}
                                            />
                                            <span>
                                                <span>Cash</span>
                                                <span>UPI</span>
                                            </span>
                                            <a></a>
                                        </label>
                                    </div>

                                    <div>
                                        <p style={{ color: 'black', fontWeight: 'bolder' }}>Net Amount : ₹{billdata[0]?.netAmount}</p>
                                    </div>

                                </div>

                            </div>
                            <div>
                                <div className="w-full mb-4 flex">
                                    <div className="w-1/2 mr-2" style={{ marginLeft: '20px' }}>
                                        <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="spareparts" style={{ fontSize: '16px' }}>
                                            Spare
                                        </label>
                                        <select
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline blackText"
                                            value={selectedSpareparts}
                                            onChange={handleSpareTypeChange}
                                        >
                                            <option value="">Spare parts</option>
                                            {sparepartsOptions.map((type) => (
                                                <option key={type.id} value={type.name}>
                                                    {type.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="w-1/6 mr-2">
                                        <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="AddressLine1">
                                            Qty
                                        </label>
                                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                            value={newItem.quantity}
                                            onChange={(e) => setNewItem({ ...newItem, quantity: e.target.value })}
                                        />
                                        {selectedSpareparts && (
                                            <div className="w-full mb-2 flex justify-end" style={{ marginLeft: '75px', marginTop: '-40px' }}>
                                                <button
                                                    className="ml-2 bg-blue-500 text-white px-3 py-2 rounded"
                                                    onClick={AddtoListdata}
                                                >
                                                    ADD
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="bg-tabcolor rounded-lg shadow-lg p-6" style={{ marginTop: '10px', backgroundColor: 'rgba(255, 255, 255, 0.5)' }}>
                                <div className="w-full mb-4 flex">
                                    <div className="w-full mb-4 flex">
                                        <TableContainer component={Paper}>
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th> Name</th>
                                                        <th>Qty</th>
                                                        <th>Rate</th>
                                                        <th>GST</th>
                                                        <th>Amount</th>
                                                    </tr>
                                                </thead>
                                                {/* <tbody>
                                                    {billdata.map((item) => (
                                                        <tr>
                                                            <td className="px-4 py-2 border-r">{item.product || item.spareparts}</td>
                                                            <td className="px-4 py-2 border-r">{item.quantity}</td>
                                                            <td className="px-4 py-2 border-r">{item.salerate}</td>
                                                            <td className="px-4 py-2 border-r">{item.gstrate}</td>
                                                            <td className="px-4 py-2">{item.inAmount}</td>

                                                        </tr>
                                                    ))}

                                                </tbody> */}
                                                <tbody>
                                                    {billdata.map((item, index) => (
                                                        <tr key={index}>
                                                            <td className="px-4 py-2 border-r">
                                                                <input
                                                                    type="text"
                                                                    value={item.product || item.spareparts}
                                                                    onChange={(e) => handleItemChange(index, 'product', e.target.value)}
                                                                />
                                                            </td>
                                                            <td className="px-4 py-2 border-r">
                                                                <input
                                                                    type="text"
                                                                    value={item.quantity}
                                                                    onChange={(e) => handleItemChange(index, 'quantity', e.target.value)}
                                                                />
                                                            </td>
                                                            <td className="px-4 py-2 border-r">
                                                                <input
                                                                    type="text"
                                                                    value={item.salerate}
                                                                    onChange={(e) => handleItemChange(index, 'salerate', e.target.value)}
                                                                />
                                                            </td>
                                                            <td className="px-4 py-2 border-r">
                                                                <input
                                                                    type="text"
                                                                    value={item.gstrate}
                                                                    onChange={(e) => handleItemChange(index, 'gstrate', e.target.value)}
                                                                />
                                                            </td>
                                                            <td className="px-4 py-2">
                                                                <input
                                                                    type="text"
                                                                    value={item.inAmount}
                                                                    onChange={(e) => handleItemChange(index, 'inAmount', e.target.value)}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>


                                            </table>


                                        </TableContainer>
                                        <Dialog
                                            open={confirmDialogOpen}
                                            onClose={closeConfirmDialog}
                                            aria-labelledby="alert-dialog-title"
                                            aria-describedby="alert-dialog-description"
                                        >
                                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                            <DialogContent>
                                                <DialogContentText id="alert-dialog-description">
                                                    Are you sure you want to delete this record?
                                                </DialogContentText>
                                            </DialogContent>

                                            <DialogActions>
                                                <button
                                                    onClick={closeConfirmDialog}
                                                    style={{
                                                        backgroundColor: '#dc3545',
                                                        color: '#ffffff',
                                                        border: '1px solid #dc3545',
                                                        borderRadius: '4px',
                                                        padding: '8px 16px',
                                                        cursor: 'pointer',
                                                        marginRight: '8px',
                                                    }}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    onClick={() => handleDelete(itemToDeleteIndex)}
                                                    style={{
                                                        backgroundColor: '#28a745',
                                                        color: '#ffffff',
                                                        border: '1px solid #28a745',
                                                        borderRadius: '4px',
                                                        padding: '8px 16px',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    Confirm
                                                </button>
                                            </DialogActions>

                                        </Dialog>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </Modal >
            </div >
        </div >
    );
}

export default WorkStatusIndex;

